import { kebabCase } from 'lodash-es';

import { COMPONENT_PREFIX } from '../constants';

export const getComponentName = (name: string) => `${COMPONENT_PREFIX}-${kebabCase(name)}`;

export const isSvelteComponent = (name: string) => /svelte$/i.test(name);
